<template>
  <div>
    <v-stepper class="stepper-component" v-model="currentSteps" alt-labels>
      <v-stepper-header>
        <v-stepper-step :complete="currentStep > 1" step="1">
          Set Up
        </v-stepper-step>
        <v-divider :style="{'border-color': (currentStep > 1 ? $vuetify.theme.primary:'') }" />
        <v-stepper-step :complete="currentStep > 2" step="2">
          Design
        </v-stepper-step>
        <v-divider :style="{'border-color': (currentStep > 2 ? $vuetify.theme.primary:'') }" />
        <v-stepper-step :complete="currentStep > 3" step="3">
          Launch
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>
<script>
import { VStepper, VStepperHeader, VStepperStep, VDivider  } from 'vuetify/lib';
import { mapGetters } from 'vuex';
export default{
  components: {
    VStepper, VStepperHeader, VStepperStep, VDivider
  },
  data(){
    return{
      step: null
    }
  },
  computed: {
    ...mapGetters(['currentStep']),
    // added currentSteps property to remove this warning
    // Computed property "currentStep" was assigned to but it has no setter.
    currentSteps: {
      get() {
        return this.currentStep;
      },
      set() {
      }
    }
  }
}
</script>
<style scoped>
::v-deep .stepper-component.v-stepper{
  box-shadow:none;
  webkit-box-shadow:none;
}
::v-deep .stepper-component.v-stepper .v-stepper__header .v-stepper__step{
  padding: 5px 0 0 0;
  margin: 0 0 0 0 ;
}
::v-deep .stepper-component.v-stepper .v-stepper__step__step{
  min-width: none !important;
}
::v-deep .stepper-component.v-stepper--alt-labels .v-stepper__header .v-divider{
  margin-top: 18px !important;
}
::v-deep .stepper-component.v-stepper .v-stepper__step .v-stepper__label{
  font-size: 12px !important;
  margin-top: 0 !important;
}
::v-deep .stepper-component.v-stepper .v-stepper__step--active .v-stepper__label{
  color:#009096 !important;
}
::v-deep .stepper-component.v-stepper .v-stepper__step--complete .v-stepper__label{
  color:#009096 !important;
}
::v-deep .stepper-component.v-stepper .v-stepper__step__step{
  margin-bottom: 0;
}
::v-deep .stepper-component.v-stepper .v-stepper__header{
  flex-wrap: nowrap;
  box-shadow:none;
  webkit-box-shadow:none;
}
@media only screen and (max-width: 959px){
::v-deep .stepper-component.v-stepper:not(.v-stepper--vertical) .v-stepper__label {
     display: block;
}
::v-deep .stepper-component.v-stepper--alt-labels .v-stepper__step{
  flex-basis: 120px;
}
::v-deep .v-stepper--alt-labels .v-stepper__header .v-divider{
  margin:0px !important
}
::v-deep .stepper-component.v-stepper .v-stepper__header .v-stepper__step{
  max-width: 50px;
}
}
</style>